<template>
    <div>
        <vs-popup
                class="vehicle-modal"
                :title="popupTitle"
                :active.sync="showPopup"
                v-if="vehicle !== null"
        >
            <template>
                <div class="vx-row">
                    <div class="vx-col w-1/2">

                        <label for="vehicle-type">Type</label>
                        <vs-select v-model="vehicle.type" class="w-full" id="vehicle-type">
                            <vs-select-item
                                    v-for="(type) in types"
                                    :key="type"
                                    :value="type"
                                    :text="type"
                            />
                        </vs-select>
                    </div>
                    <div class="vx-col w-1/2">

                        <label for="vehicle-type">Status</label>
                        <vs-select v-model="vehicle.status" class="w-full" id="vehicle-status">
                            <vs-select-item
                                    v-for="(state) in states"
                                    :key="state.value"
                                    :value="state.value"
                                    :text="state.name"
                            />
                        </vs-select>
                    </div>
                </div>

                <div class="vx-row ">
                    <div class="vx-col w-1/2">
                        <vs-input v-model="vehicle.license_plate" label="Kenteken" class="w-full"></vs-input>
                    </div>
                    <div class="vx-col w-1/2">

                        <vs-select v-model="vehicle.deliverer" class="w-full" id="vehicle-deliverer" label="Bezorger">
                            <vs-select-item
                                    key="0"
                                    value="0"
                                    text="Geen bezorger"
                            >
                            </vs-select-item>
                            <vs-select-item
                                    v-for="(deliverer) in deliverers"
                                    :key="deliverer.id"
                                    :value="deliverer.id"
                                    :text="deliverer.name"
                            />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row ">
                    <div class="vx-col w-1/2">
                        <vs-input v-model="vehicle.name" label="Naam" class="w-full"></vs-input>
                    </div>
                </div>
                <br>

                <div class="vx-col">
                    <vs-button
                            class="mr-3 mb-2 vs-con-loading__container"
                            id="save-vehicle-button"
                            ref="loadableButton"
                            @click="saveVehicle"
                            :disabled="canSave"
                            style="float: right"
                    >Opslaan
                    </vs-button>
                </div>
            </template>
        </vs-popup>
        <vs-popup
                class="deliverer-modal"
                title="Voertui bewerken"
                :active.sync="showCreatePopup"
                v-if="createVehicle !== null"
        >
            <template>
                <div class="vx-row">
                    <div class="vx-col w-1/2">

                        <label for="vehicle-type">Type</label>
                        <vs-select v-model="createVehicle.type" class="w-full" id="create-vehicle-type">
                            <vs-select-item
                                    v-for="(type) in types"
                                    :key="type"
                                    :value="type"
                                    :text="type"
                            />
                        </vs-select>
                    </div>
                    <div class="vx-col w-1/2">

                        <label for="vehicle-type">Status</label>
                        <vs-select v-model="createVehicle.status" class="w-full" id="create-vehicle-status">
                            <vs-select-item
                                    v-for="(state) in states"
                                    :key="state.value"
                                    :value="state.value"
                                    :text="state.name"
                            />
                        </vs-select>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-1/2">
                        <vs-input v-model="createVehicle.license_plate" label="Kenteken" class="w-full"></vs-input>
                    </div>
                    <div class="vx-col w-1/2">

                        <vs-select v-model="createVehicle.delivererId" class="w-full" id="vehicle-create-deliverer"
                                   label="Bezorger">
                            <vs-select-item
                                    key="0"
                                    value="0"
                                    text="Geen bezorger"
                            >
                            </vs-select-item>
                            <vs-select-item
                                    v-for="(deliverer) in deliverers"
                                    :key="deliverer.id"
                                    :value="deliverer.id"
                                    :text="deliverer.name"
                            />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-1/2">
                        <vs-input v-model="createVehicle.name" label="Naam" class="w-full"></vs-input>
                    </div>
                </div>
                <br>

                <div class="vx-col">
                    <vs-button
                            class="mr-3 mb-2 vs-con-loading__container"
                            id="create-vehicle-button"
                            ref="loadableButton"
                            @click="createVehicleModal"
                            :disabled="canSave"
                            style="float: right"
                    >Opslaan
                    </vs-button>
                </div>
            </template>
        </vs-popup>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                showPopup: false,
                showCreatePopup: false,
                vehicle: null,
                loading: false,
                companies: [],
                company: null,
                nodeliverer: "Geen bezorger",
                deliverers: [],
                types: [
                    'E_BIKE',
                    'POWERBANK',
                    'E_SCOOTER'
                ],
                states: [
                     {
                         'name': 'Beschikbaar',
                         'value': 'AVAILABLE'
                     },

                    {
                        'name': 'In onderhoud',
                        'value': 'MAINTENANCE'
                    },
                    {
                        'name': 'Uit Roullete',
                        'value': 'OUT_OF_ROULETTE'
                    },
                ],
                createVehicle: {
                    type: 'E_BIKE',
                    status: 'AVAILABLE',
                    license_plate: '',
                    name: '',
                    company_id: 57,
                    region: "Spijkenisse",
                    delivererId: 0
                }
            };
        },
        computed: {
            canSave() {
                return this.loading;
            },
            popupTitle() {
                return "Entiteit " + this.vehicle.name + " bewerken";
            }
        },
        watch: {
            showPopup: function () {
                if (this.showPopup) {
                    this.companies.map((company) => {
                        if (company.id === this.invoiceAble.company.id) {
                            this.company = company;
                        }
                    });
                }
            }
        },
        methods: {
            saveVehicle() {
                this.$util.loading('#save-vehicle-button', this.$vs);
                this.loading = true;
                let data = new FormData();
                data.append('_method', 'PUT');
                data.append('_id', this.vehicle._id);
                data.append('type', this.vehicle.type);
                data.append('status', this.vehicle.status);
                data.append('license_plate', this.vehicle.license_plate);
                data.append('company_id', this.vehicle.company_id);
                data.append('deliverer', this.vehicle.deliverer);
                data.append('name', this.vehicle.name);
                this.$http
                    .post("v1/vehicle/update", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then(() => {
                        this.showPopup = false;
                        this.loading = false;
                        this.$vs.loading.close('#save-vehicle-button > .con-vs-loading');
                        this.$util.notify('Gelukt', 'Voertuig is opgeslagen', this.$vs);
                    })
                    .catch((error) => {
                        this.$vs.loading.close("#save-vehicle-button > .con-vs-loading");
                        this.loading = false;
                        this.$util.logError(error, this.$vs);
                    });
            },
            getDeliverers() {
                this.$http.get('https://api.staging.hebtrek.nl/staff/deliverers')
                    .then((response) => {
                        this.deliverers = response.data;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
            createVehicleModal() {
                this.$util.loading('#create-vehicle-button', this.$vs);
                this.loading = true;
                let data = new FormData();
                data.append('_method', 'POST');
                data.append('type', this.createVehicle.type);
                data.append('status', this.createVehicle.status);
                data.append('license_plate', this.createVehicle.license_plate);
                data.append('company_id', this.createVehicle.company_id);
                data.append('deliverer_id', this.createVehicle.deliverer);
                data.append('name', this.createVehicle.name);
                this.$http
                    .post("v1/vehicle/create", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then(() => {
                        this.showCreatePopup = false;
                        this.loading = false;
                        this.$events.fire('refresh-vehicles');
                        this.$vs.loading.close('#create-vehicle-button > .con-vs-loading');
                        this.$util.notify('Gelukt', 'Voertuig is opgeslagen', this.$vs);
                    })
                    .catch((error) => {
                        this.$vs.loading.close("#create-vehicle-button > .con-vs-loading");
                        this.loading = false;
                        this.$util.logError(error, this.$vs);
                    });
            },
        },

        mounted() {
            this.getDeliverers();
            this.$events.listen('open-vehicle-modal', (vehicle) => {
                this.vehicle = vehicle;
                this.showPopup = true;
            });
            this.$events.listen('open-create-vehicle-modal', () => {
                this.showCreatePopup = true;
            });
            window.addEventListener('keyup', (key) => {
                if (key.keyCode === 27) {
                    this.showPopup = false;
                }
            });
        }
    };
</script>
<style>
    .mr-3 {
        padding-right: 0;
    }
</style>
